import React, {ReactElement} from 'react';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import Select from 'react-select';
import {customStyles} from './dropdownStyle';
import BuddyDatePicker from '../datepicker';
import whatsapp from '../../assets/images/whatsapp.svg';

type CustomerProfileData = {
  result: boolean;
  resultCode: string;
  message: string;
  firstName: string;
  lastName: string | null;
  tier: string;
  pointsAvailable: number;
  pointToExpire: number;
  cardNumber: string;
  email: string;
  gender: string;
  dob: string;
  pincode:string;
};

const options = [
  {value: 'M', label: 'Male'},
  {value: 'F', label: 'Female'},
];

type ContentContainerProps = {
  buttonTitle: string;
  submitCallback: any;
  openTnCModal: () => void;
  customerProfileData?: CustomerProfileData | null;
};
const EnrolmentForm: React.FC<ContentContainerProps> = ({
  buttonTitle,
  submitCallback,
  openTnCModal,
  customerProfileData,
}: ContentContainerProps): ReactElement => {
  const getGender = () => {
    if (customerProfileData?.gender) {
      if (
        customerProfileData.gender == 'M' ||
        customerProfileData.gender.toLowerCase() === 'male' ||
        customerProfileData.gender.toLowerCase() === 'Male'
      ) {
        return options[0];
      } else {
        return options[1];
      }
    }
  };

  function getDateOfBirth() {
    console.error('getDateOfBirth');
    console.error(customerProfileData);
    if (customerProfileData?.dob) {
      return moment(customerProfileData.dob, "YYYY-MM-DD hh:mm:ss").toDate();
    } else return '';
  }

  const initialValues = {
    firstname: customerProfileData?.firstName
      ? customerProfileData.firstName
      : '',
    lastname: customerProfileData?.lastName ? customerProfileData.lastName : '',

    email: customerProfileData?.email ? customerProfileData.email : '',
    gender: getGender(),
    whatsappApi: true,
    dateOfBirth: getDateOfBirth(),
    pincode:customerProfileData?.pincode?customerProfileData.pincode:'',
  };
  const validationSchema = Yup.object({
    firstname: Yup.string()
      .matches(/^[aA-zZ\s]+$/, 'Characters allowed only')
      .max(200, 'Max length exceeding')
      .required('*Please enter first name'),

    lastname: Yup.string().matches(/^[aA-zZ\s]+$/, 'Character allowed only'),
    email: Yup.string()
      .max(60, 'Max length execeeding')
      .email('Invalid email format'),
    dateOfBirth: Yup.date()
      .typeError('*Please enter D.O.B.')
      .max(new Date(Date.now() - 568025136000), 'Age must be 18+')
      .min(new Date(Date.now() - 3124138248000), 'Age must be below 99')
      .required('*Please enter D.O.B.'),
    pincode:Yup.string().required('Please enter pincode').min(6,'Please enter altleast 6 digits').max(6,'Enter 6 digits only').matches(/^\d+$/, 'Enter 6 digits only'),
  });
  const onSubmit = (
    values: any,
    submitProps: {
      setSubmitting: (arg0: boolean) => void;
      resetForm: () => void;
    },
  ) => {
    submitProps.setSubmitting(false);
    let date = '';
    if (values.dateOfBirth) {
      date = moment(values.dateOfBirth).format('DD-MMM-YYYY');
    }
    const formData = {
      date,
      email: values.email,
      firstName: values.firstname,
      lastName: values.lastname,
      gender: values.gender?.value,
      whatsappAPI: values.whatsappApi,
      pincode: values.pincode,
    };
    submitCallback(formData);
    //submitProps.resetForm();
  };

  return (
    <Formik
      className="flex justify-items-stretch mx-auto max-w-screen-md relative flex-grow +
      (buttonTitle === 'Create profile' ? 'p-6' : '')"
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize>
      {formik => {
        return (
          <Form>
            <div className=" w-full grid grid-cols-2 gap-x-4 gap-y-6 mt-8">
              <div>
                <div
                  className={`grid h-50 border-opacity-50 rounded-radius10  bg-blue_four hover:bg-white   ${
                    formik.errors.firstname &&
                    formik.values.firstname.length > 0
                      ? 'input_error'
                      : 'input_valid'
                  }`}>
                  <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                    First name <span className="text-dark_red">*</span>
                  </span>
                  <Field
                    type="text"
                    name="firstname"
                    placeholder="Enter first name"
                    className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                  />
                </div>
                {(formik.errors.firstname && formik.touched.firstname) ||
                formik.values.firstname.length > 0 ? (
                  <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                    {formik.errors.firstname}
                  </div>
                ) : null}
              </div>
              <div>
                <div
                  className={`grid h-50 border-opacity-50 rounded-radius10 bg-blue_four hover:bg-white ${
                    formik.errors.lastname ? 'input_error' : 'input_valid'
                  }`}>
                  <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                    Last name
                  </span>
                  <Field
                    type="text"
                    name="lastname"
                    placeholder="Enter last name"
                    className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                  />
                </div>
                {formik.errors.lastname || formik.touched.lastname ? (
                  <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                    {formik.errors.lastname}
                  </div>
                ) : null}
              </div>

              <div
                className={`grid h-50 border-opacity-50 rounded-radius10 bg-blue_four  hover:bg-white input_valid`}>
                <span
                  className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold"
                  style={{lineHeight: 0, marginTop: '13px'}}>
                  Gender
                </span>
                <Field
                  as="select"
                  name="gender"
                  className="grid place-items-center w-full">
                  {({form, field}: any) => {
                    const {setFieldValue} = form;
                    const {value} = field;
                    return (
                      <Select
                        placeholder="Select"
                        styles={customStyles}
                        value={value}
                        onChange={val => setFieldValue(field.name, val)}
                        options={options}
                        className="font-roboto h-50"
                        isSearchable={false}
                      />
                    );
                  }}
                </Field>
              </div>

              <div>
                <div
                  className={`grid h-50 border-opacity-50 rounded-radius10 bg-blue_four hover:bg-white  ${
                    formik.errors.dateOfBirth && formik.touched.dateOfBirth
                      ? 'input_error'
                      : 'input_valid'
                  }`}>
                  <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1 font-bold">
                    Date of birth <span className="text-dark_red">*</span>
                  </span>
                  <Field name="dateOfBirth">
                    {({form, field}: any) => {
                      const {setFieldValue} = form;
                      const {value} = field;
                      return (
                        <BuddyDatePicker
                          dateFormat="DD/MM/YYYY"
                          onCancelPressed={() => {
                            formik.touched.dateOfBirth = true;
                            formik.setValues({
                              ...formik.values,

                              dateOfBirth: formik.values.dateOfBirth || '',
                            });
                          }}
                          onDateSelected={date => {
                            formik.touched.dateOfBirth = true;
                            setFieldValue(field.name, date);
                          }}
                          initialValue={value}
                        />
                      );
                    }}
                  </Field>
                </div>
                {formik.errors.dateOfBirth && formik.touched.dateOfBirth ? (
                  <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                    {formik.errors.dateOfBirth}
                  </div>
                ) : null}
              </div>
              <div
                className={`grid h-50 border-opacity-50 rounded-radius10 bg-blue_four hover:bg-white col-span-2 ${
                  formik.errors.email ? 'input_error' : 'input_valid'
                }`}>
                <span className="col-span-2 text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                  Email
                </span>
                <Field
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  className="focus:outline-none w-full font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                />
              </div>
              {formik.errors.email && formik.touched.email ? (
                <div className="col-span-2">
                  <div className="text-red-600 text-xs font-roboto ml-2.5 -mt-4">
                    {formik.errors.email}
                  </div>
                </div>
              ) : null}
              <div>
                <div
                  className={`grid h-50 border-opacity-50 rounded-radius10 bg-blue_four hover:bg-white ${
                    formik.errors.pincode ? 'input_error' : 'input_valid'
                  }`}>
                  <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                    Pincode <span className="text-dark_red">*</span>
                  </span>
                  <Field
                    type="number"
                    name="pincode"
                    placeholder="Enter pincode"
                    className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                  />
                </div>
                {formik.errors.pincode || formik.touched.pincode ? (
                  <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                    {formik.errors.pincode}
                  </div>
                ) : null}
              </div>

              <div
                className={`col-span-2 ${
                  buttonTitle === 'Create profile' ? '-mt-5' : 'mt-4'
                } `}>
                {buttonTitle === 'Create profile' && (
                  <div className="flex items-center">
                    <div className="checkbox-wrapper block m-auto">
                      <label className="text-xxs font-roboto checkbox-container flex items-center">
                        <span className="flex items-center flex-wrap h-7 pt-1">
                          Receive notifications and bills on&nbsp;
                          <span className="flex items-center h-6">
                            <strong>WhatsApp</strong>
                            <img src={whatsapp} width="19" height="20" />
                          </span>
                        </span>
                        <Field type="checkbox" name="whatsappApi" />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                )}
                <div className="col-span-2 mt-12 text-center text-xs font-roboto">
                  <span
                    onClick={openTnCModal}
                    className="p-2 text-red_zero font-bold ">
                    Landmark Rewards T&C
                  </span>
                </div>
              </div>
              <div className="col-span-2">
                <button
                  className={`cursor-none-allowed text-white h-50 rounded-radius10  grid place-items-center focus:outline-none w-full text-center primary normal`}
                  type="submit"
                  disabled={!(formik.dirty && formik.isValid)}>
                  <p className="font-bold font-roboto">{buttonTitle}</p>
                </button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default EnrolmentForm;
